import React, {useEffect, useState} from 'react';

import TransferList from './common/TransferList';
import {
    Container,
    CardHeader,
    CardContent,
    CardActions,
    Card,
    Button,
    Typography,
} from '@mui/material';
import {loadPaylogikUser} from '../redux/store/authSlice';
import {useDispatch} from 'react-redux';
import { CustomerReferenceCodeVm, useGetCustomerDataEntryCodesForUserQuery, UserConfigurationVm, useSaveMyConfigMutation } from '../redux/rtkquery/paylogikApi';
import { useAppSelector } from '../redux/functions/hooks';
import {toast} from '../functions/toast';

export default function UserSettings(props) {
    const [refCodes, setRefCodes] = useState<CustomerReferenceCodeVm[]>();
    const [userConfig, setUserConfig] = useState<UserConfigurationVm>();
    const [selectedRefCodes, setSelectedRefCodes] = useState([]);
    const myUserConfig = useAppSelector((x) => x.auth.user.userConfiguration);

    //const {data: userConfigLoaded, isLoading: userConfigIsLoading} = useGetMyUserQuery()

    const {data: customerDataEntryCodes, isLoading: cdeIsLoading} = useGetCustomerDataEntryCodesForUserQuery()
    const [saveMyConfig,{isLoading: saveMyConfigIsLoading}] = useSaveMyConfigMutation();

    useEffect(()=>{
        setUserConfig(myUserConfig);
        setSelectedRefCodes(myUserConfig?.invoiceResearchCustomColumns);
    }, [myUserConfig])

    useEffect(()=>{
        setRefCodes(customerDataEntryCodes)
    }, [customerDataEntryCodes])

    const onSelectionChanged = (e) => {
        setSelectedRefCodes(e);
        setUserConfig((prev) => {
            return {...prev, invoiceResearchCustomColumns: e};
        });
    };

    const dispatch = useDispatch();

    const saveUserConfig = async () => {

        // userConfig.invoiceResearchCustomColumns =
        //     userConfig.invoiceResearchCustomColumns.map((i, idx) => {
        //         i.displayOrder = idx;
        //         return i;
        //     });

        await saveMyConfig({userConfigurationVm: userConfig});
        dispatch(loadPaylogikUser());

        toast.success('Successfully saved Reference columns.');
    };

    return (
        <Container>
            <Card>
                <CardHeader title="Invoice Research Reference Codes"></CardHeader>
                <CardContent>
                    <Typography>
                        Select the reference codes you would like to appear in
                        the invoice research data grid in addition to the
                        standard columns
                    </Typography>

                    <TransferList
                        sourceData={refCodes || []}
                        value={selectedRefCodes || []}
                        onChange={onSelectionChanged}
                        render={(item) => item.name}
                        keySelector={(item) => item.code}
                    />
                </CardContent>
                <CardActions>
                    <Button onClick={saveUserConfig}>Save</Button>
                </CardActions>
            </Card>
        </Container>
    );
}
